// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-form[data-v-61bf256c]:after{background-color:#ff1744!important}.logo-image[data-v-61bf256c]{filter:invert(100%) sepia(100%) saturate(0) hue-rotate(149deg) brightness(109%) contrast(101%)}", ""]);
// Exports
module.exports = exports;
